/* eslint-disable max-len */
export const EXTERNAL_LINKS = {
  TERMS: "https://goodvets.com/totalcare-terms",
  PRIVACY_POLICY: "https://web.good-vets.com/privacy-policy",
} as const;

export const MESSAGES = {
  SERVICE_UNAVAILABLE: "Wellness Plan Service is temorarily unavailable!",
  ELIGIBILITY_ERROR: "Unable to check ScratchPay eligibility. Please try again or select annual payment.",
  ELIGIBILITY_CHECKING: "Checking eligibility...",
  ELIGIBILITY_VERIFICATION_FAILED: "Unable to verify eligibility. Please try annual payment.",
  PAYMENT_MANAGED_BY_SCRATCHPAY: "Payment will be managed through ScratchPay",
  SCRATCHPAY_NOT_ELIGIBLE: "You don't qualify for monthly payments with Scratch. Select annual payment to purchase. ",
  SCRATCHPAY_DENIED: "Your monthly plan couldn't be approved, but you can still continue with an annual plan.",
  RENEWAL_ERROR: "There was an error renewing your subscription. Please contact support for further assistance.",
  PAYMENT_INPUT_DATA_ERROR: "There was an error processing your request. Please try again.",
  PAYMENT_PROCESSING_TITLE: "Processing Your Payment",
  PAYMENT_PROCESSING_DESCRIPTION: "Please don't close this window or navigate away while we complete your transaction.",
} as const;

export const SECTION_TITLES = {
  PAYMENT_PLAN: "Payment Plan",
  PAYMENT_METHOD: "Payment Method",
  PURCHASE_SUMMARY: "Purchase Summary",
} as const;

export const BUTTON_TEXT = {
  // "Continue" per Figma review #992 — accurate for monthly, which hands off
  // to Scratch. Annual keeps "Confirm & Pay": on web that click executes the
  // charge directly (mobile has a separate checkout step, web does not).
  CONTINUE_SCRATCHPAY: "Continue",
  CONFIRM_PURCHASE: "Confirm & Pay",
  ADD_PAYMENT_METHOD: "Add Payment Method",
} as const;

export const getMonthlyScratchPayText = (monthlyAmount: string) =>
  `Cover your pet's annual care with 12 monthly payments starting at ${monthlyAmount}/month.`;

export const ANNUAL_ENROLLMENT_TEXT =
"Save when you make a one-time annual payment for the full cost of the Wellness Plan today.";
